import { schema } from 'normalizr';

import { businessInformationTemplate } from './businessInformationTemplate';

export const technicalInformation = new schema.Entity('technicalInformations', {
  template: businessInformationTemplate,
});

export const technicalInformations = new schema.Array(technicalInformation);
